export function isHubSpotSupportedCountry(countryCode) {
  return countryCode === undefined || countryCode === 'US' || countryCode === 'CA' || countryCode === 'GB';
}